import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import SearchBar from "material-ui-search-bar";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return -1;
  } else if (b[orderBy] === null) {
    return 1;
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  console.log(array);
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "changeDate", label: "Date" },
  { id: "phoneNumber", label: "Number" },
  { id: "gmid", label: "GMID/GMIN" },
  { id: "action", label: "Action" },
  { id: "changedBy", label: "Changed By" },
];

function EnhancedTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    handleSearch,
    handleCancelSearch,
    searched,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell style={{ minWidth: "116px" }} />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            paddingBottom="50px"
            style={{ fontSize: "1vw", padding: "5px" }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <div
              class="input-group"
              style={{
                justifyContent: "center",
                marginBottom: "8px",
                minWidth: "230px",
              }}
            >
              {headCell.id === "phoneNumber" && (
                <SearchBar
                  placeholder="Number"
                  value={searched}
                  onChange={(searchVal) => handleSearch(searchVal, "number")}
                  onCancelSearch={() => handleCancelSearch()}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id === "gmid" && (
                <SearchBar
                  placeholder="GMID/GMIN"
                  value={searched}
                  onChange={(searchVal) => handleSearch(searchVal, "gmid")}
                  onCancelSearch={() => handleCancelSearch()}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}

              {headCell.id != "action" && headCell.id != "phoneNumber" && (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {(headCell.id == "changedBy" ||
                    headCell.id == "changeDate") && (
                    <div align="center" style={{ fontSize: ".9vw" }}>
                      {headCell.label}
                    </div>
                  )}
                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              )}
            </div>

            {headCell.id === "action" && (
              <select
                class="form-control"
                type="text"
                name="serviceManager"
                style={{
                  width: "125px",
                  height: "40px",
                  fontSize: ".75vw",
                  margin: "auto",
                  marginBottom: "12px",
                }}
                onChange={(v) =>
                  handleSearch(v.target.value.toString(), "action")
                }
              >
                <option value=""> Action </option>
                <option value="Insert">Insert</option>
                <option value="Update">Update</option>
                <option value="Delete">Delete</option>
              </select>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Teams Endpoint Audit
      </Typography>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  searchbar: {
    width: "200px",
    height: "40px",
  },
}));

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  subTable: {
    "& td": {
      width: "33%",
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});

const getDateFormat = (date) => {
  if (date == null) return;
  var newDate = date.split("T")[0];
  var dateArray = newDate.split("-");
  var year = dateArray[0].substring(2);
  var month = dateArray[1];
  var day = dateArray[2];
  var fullTime = date.split("T")[1].split(".")[0];
  var hour = fullTime.substring(0, 2);
  var finalTime;
  if (parseInt(hour) > 12) {
    if (parseInt(hour) > 21) {
      finalTime = hour - 12 + fullTime.substring(2, 5);
    } else {
      finalTime = "0" + (hour - 12) + fullTime.substring(2, 5);
    }
    finalTime += " PM";
  } else {
    finalTime = hour + fullTime.substring(2, 5);
    finalTime += " AM";
  }
  var myDate = `${month}/${day}/${year} - ${finalTime}`;
  return myDate;
};
function CollapsedRows(props) {
  const { row, index } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow
        className={classes.root}
        style={index % 2 ? { background: "#f8f8f8" } : { background: "white" }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center">{getDateFormat(row.changeDate)}</TableCell>
        {row.action !== "Delete" ? (
          <>
            <TableCell align="center" style={{ width: "20%" }}>
              {row.newPhoneNumber}
            </TableCell>
            <TableCell align="center" style={{ width: "20%" }}>
              {row.newGmid}
              {row.newGmid && row.newGmin ? "/" : ""}
              {row.newGmin}
            </TableCell>
          </>
        ) : (
          <>
            <TableCell align="center" style={{ width: "20%" }}>
              {row.phoneNumber}
            </TableCell>
            <TableCell align="center" style={{ width: "20%" }}>
              {row.gmid}
              {row.gmid && row.gmin ? "/" : ""}
              {row.gmin}
            </TableCell>
          </>
        )}
        <TableCell align="center">{row.action}</TableCell>
        <TableCell align="center">{row.changedBy}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Change Made
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Details</TableCell>
                    <TableCell>Before</TableCell>
                    <TableCell>After</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.subTable}>
                  <TableRow style={{ background: "#F8F8F8" }}>
                    <TableCell style={{ borderLeft: "none" }}>
                      Phone Number
                    </TableCell>
                    <TableCell>{row.phoneNumber}</TableCell>
                    <TableCell
                      style={{
                        borderLeft: "1px solid rgba(224, 224, 224, 1)",
                        fontWeight:
                          row.phoneNumber != null &&
                          row.phoneNumber != row.newPhoneNumber
                            ? "bold"
                            : "normal",
                      }}
                    >
                      {row.newPhoneNumber}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ borderLeft: "none" }}>
                      Display Name
                    </TableCell>
                    <TableCell>{row.displayName}</TableCell>
                    <TableCell
                      style={{
                        borderLeft: "1px solid rgba(224, 224, 224, 1)",
                        fontWeight:
                          row.displayName != null &&
                          row.displayName != row.newDisplayName
                            ? "bold"
                            : "normal",
                      }}
                    >
                      {row.newDisplayName}
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: "#F8F8F8" }}>
                    <TableCell style={{ borderLeft: "none" }}>
                      Pool Name
                    </TableCell>
                    <TableCell>
                      {(row.action == "Update" || row.action == "Delete") &&
                        row.poolName}
                    </TableCell>
                    <TableCell
                      style={{
                        borderLeft: "1px solid rgba(224, 224, 224, 1)",
                        fontWeight:
                          row.poolName != null && row.poolName != row.poolName
                            ? "bold"
                            : "normal",
                      }}
                    >
                      {(row.action == "Update" || row.action == "Insert") &&
                        row.poolName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ borderLeft: "none" }}>
                      Dial Plan
                    </TableCell>
                    <TableCell>{row.dialPlan}</TableCell>
                    <TableCell
                      style={{
                        borderLeft: "1px solid rgba(224, 224, 224, 1)",
                        fontWeight:
                          row.dialPlan != null &&
                          row.dialPlan != row.newDialPlan
                            ? "bold"
                            : "normal",
                      }}
                    >
                      {row.newDialPlan}
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: "#F8F8F8" }}>
                    <TableCell style={{ borderLeft: "none" }}>
                      Voice Policy
                    </TableCell>
                    <TableCell>{row.voicePolicy}</TableCell>
                    <TableCell
                      style={{
                        borderLeft: "1px solid rgba(224, 224, 224, 1)",
                        fontWeight:
                          row.voicePolicy != null &&
                          row.voicePolicy != row.newVoicePolicy
                            ? "bold"
                            : "normal",
                      }}
                    >
                      {row.newVoicePolicy}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ borderLeft: "none" }}>
                      SIP Address
                    </TableCell>
                    <TableCell>{row.sipAddress}</TableCell>
                    <TableCell
                      style={{
                        borderLeft: "1px solid rgba(224, 224, 224, 1)",
                        fontWeight:
                          row.sipAddress != null &&
                          row.sipAddress != row.newSipAddress
                            ? "bold"
                            : "normal",
                      }}
                    >
                      {row.newSipAddress}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const TeamsEndpointAuditTable = (props) => {
  const classes = useStyles();
  const { endpointAudits } = props;
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = useState(endpointAudits);
  const [searched, setSearched] = useState("");

  console.log(endpointAudits);

  const requestSearch = (searchedVal, domain) => {
    setPage(0);
    const search = searchedVal.toLowerCase();

    const filteredRows = endpointAudits.filter((row) => {
      let values = [];

      if (domain === "number") {
        values = [row.phoneNumber, row.newPhoneNumber];
      } else if (domain === "gmid") {
        values = [row.gmid, row.newGmid, row.gmin, row.newGmin];
      } else if (domain === "action") {
        values = [row.action, row.newAction];
      }

      return values.some(
        (val) => val != null && val.toString().toLowerCase().includes(search)
      );
    });

    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched, "action"); // Domain set to anything will work here, without cancel will break as none of the request search options will be hit!
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              handleSearch={requestSearch}
              handleCancelSearch={cancelSearch}
              searched={searched}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return <CollapsedRows row={row} index={index} />;
                })}
              {emptyRows > 0 && rows.length >= rowsPerPage && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
          onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
          onPageChange={handleChangePage} // Material v > 4
          onChangePage={handleChangePage} // Material v < 4
        />
      </Paper>
    </div>
  );
};

export default TeamsEndpointAuditTable;
